<template>
  <div>
    <div class="activation-step">
      <div :class="['step',index<activeNum?'step-active':'step-normal']" v-for="(item,index) of stepList" :key="index">
        <div class="step-num">{{item.index}}</div>
        <div class="step-info">{{item.title}}</div>
      </div>
      <div class="step-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeNum: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      active: 1,
      stepList: [
        {
          index: 1,
          title: '网站条款'
        },
        {
          index: 2,
          title: '确认注册资料'
        },
        {
          index: 3,
          title: '修改密码'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.activation-step{
  width: 100%;
  background: rgb(255, 255, 255);
  height: 80px;
  display: flex;
  position: relative;
}
.step{
  flex: 1;
  text-align: center;
  margin-top: 10px;
  z-index: 1;
}
.step-line{
  width: 60%;
  height: 2px;
  background-color: #c0c0c0;
  position: absolute;
  left: 20%;
  top: 25px;
  z-index: 0;
}
.step-num{
  width: 30px;
  height: 30px;
  border: 1px solid grey;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-size: 18px;
  margin-left: 35%;
  margin-bottom:10px;
}
.step-active{
  color: #00545e;
  .step-num{
    color:white;
    background-color: #00545e;
  }
}
.step-normal{
  color: grey;
  .step-num{
    background-color: #f0f0f0;
  }
}

</style>
